export default "__VITE_ASSET__b2a031e9__"